import { useState } from "react";
import { MoreHorizontal, Trash2, UserCheck } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";
import { adminHeaders, type LmsComp, type LmsPlayer } from "../../lib/lms";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "./ui";

export function PlayerMenu({ comp, p, onChange }: { comp: LmsComp; p: LmsPlayer; onChange: (c: LmsComp) => void }) {
  const [confirm, setConfirm] = useState(false);
  const run = async (fn: () => Promise<{ data: LmsComp }>, msg: string) => {
    try { const { data } = await fn(); onChange(data); toast.success(msg); } catch (e) { toast.error(apiError(e)); }
  };
  const reinstate = () => run(() => api.post(`/lms/${comp.id}/players/${p.id}/reinstate`, {}, adminHeaders(comp.id)), `${p.name} is back in`);
  const remove = () => run(() => api.delete(`/lms/${comp.id}/players/${p.id}`, adminHeaders(comp.id)), `${p.name} removed`);
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger className="rounded-lg p-1 hover:bg-black/10" aria-label={`Manage ${p.name}`} data-testid={`lms-player-menu-${p.id}`}><MoreHorizontal className="h-4 w-4" strokeWidth={3} /></DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="border-2 border-[#0B1F33] font-bold">
          {!p.alive && <DropdownMenuItem onClick={reinstate} data-testid={`lms-reinstate-${p.id}`}><UserCheck className="mr-2 h-4 w-4" /> Bring back</DropdownMenuItem>}
          <DropdownMenuItem onClick={() => setConfirm(true)} className="text-[#C8102E]" data-testid={`lms-remove-${p.id}`}><Trash2 className="mr-2 h-4 w-4" /> Remove player</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <AlertDialog open={confirm} onOpenChange={setConfirm}>
        <AlertDialogContent className="border-[3px] border-[#0B1F33]" data-testid="lms-remove-confirm-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle className="font-comic text-2xl">Remove {p.name}?</AlertDialogTitle>
            <AlertDialogDescription>Are you sure? This deletes {p.name} and their picks from the competition. It can't be undone.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="lms-remove-cancel">Cancel</AlertDialogCancel>
            <AlertDialogAction className="bg-[#C8102E] hover:bg-[#a50d26]" onClick={remove} data-testid="lms-remove-confirm">Yes, remove</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
